import { CostCenterDtotoCostCenter, MediationDtoToMediantion, MediationListDtoToMediantionList, PaymentOptionsDtoToPaymentOptions, PaymentResumeDtoToPaymentResume, } from '../../mappers/financial';
import { api } from './api';
export const FinancialApi = api.injectEndpoints({
    endpoints: (builder) => ({
        mediationList: builder.query({
            query: params => ({
                method: 'get',
                url: `api/faturamento/Medidas/${params.selected}`,
                params: {
                    from: params.startDate,
                    to: params.endDate,
                    page: params.page || 1,
                    limit: params.quantity || 5,
                    billed: params.filtredOption,
                },
            }),
            transformResponse: (response) => MediationListDtoToMediantionList(response),
        }),
        mediationById: builder.query({
            query: ({ id }) => ({
                method: 'get',
                url: `api/faturamento/MedidaPorId/${id}`,
            }),
            transformResponse: (response) => MediationDtoToMediantion(response),
        }),
        support: builder.query({
            query: ({ id }) => ({
                method: 'get',
                url: `api/faturamento/ResponsavelFaturamento/${id}`,
            }),
        }),
        paymentResume: builder.query({
            query: ({ id }) => ({
                method: 'get',
                url: `api/faturamento/ResumoFatura/${id}`,
            }),
            transformResponse: (response) => PaymentResumeDtoToPaymentResume(response),
        }),
        paymentOptions: builder.query({
            query: ({ id }) => ({
                method: 'get',
                url: `api/faturamento/OpcoesPagamento/${id}`,
            }),
            transformResponse: (response) => PaymentOptionsDtoToPaymentOptions(response),
        }),
        handleMediation: builder.mutation({
            query: ({ id, approve, justification, costCenter }) => ({
                method: 'post',
                url: `api/faturamento/AprovaOuContestaFatura/${id}`,
                data: { approve, justification, costCenter },
            }),
        }),
        getCostCenter: builder.query({
            query: groupsString => ({
                method: 'get',
                url: `api/faturamento/ObterCostCenters?${groupsString}`,
            }),
            transformResponse: (response) => CostCenterDtotoCostCenter(response),
        }),
        sendEmail: builder.mutation({
            query: ({ email }) => ({
                method: 'post',
                url: 'api/faturamento/enviartoken',
                data: { email },
            }),
        }),
        sendToken: builder.mutation({
            query: ({ email, token }) => ({
                method: 'post',
                url: 'api/faturamento/validartoken',
                data: { email, token },
            }),
        }),
    }),
});
export const { useHandleMediationMutation, usePaymentOptionsQuery, usePaymentResumeQuery, useSupportQuery, useMediationListQuery, useMediationByIdQuery, useLazyGetCostCenterQuery, useLazyMediationListQuery, useSendEmailMutation, useSendTokenMutation, } = FinancialApi;
